<template>
    <div class="card section-item-order-data-container">
        <div class="row justify-content-center section-personal-data">
            <div class="col-md-12 text-center mt-2 pb-0">
                <h5 class="text-start mb-0 title-landing"><i class="fa-solid fa-user icon-option"></i>
                    Datos del Pedido</h5>
                            <ModalPdf/>
            </div>
        </div>
        <hr>
            <div class="row justify-content-start section-personal-data">
            <div class="col-md-12">
                <div class="row justify-content-start">
                    <div class="col-md-6">
                        <label for="nombre" class="text-gray-600 small">Nombre</label>
                        <input type="text" placeholder="" v-model="name" id="nombre" aria-label="nombre"
                            :class="['form-control', 'form-control-solid', 'send-data', { 'is-invalid': fieldError('name') }]">
                        <div v-if="fieldError('name')" class="invalid-feedback d-block">{{ fieldError('name') }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="apellido" class="text-gray-600 small">Apellido</label>
                        <input type="text" placeholder="" v-model="lastName" id="apellido" aria-label="apellido"
                            :class="['form-control', 'form-control-solid', 'send-data', { 'is-invalid': fieldError('lastName') }]">
                        <div v-if="fieldError('lastName')" class="invalid-feedback d-block">{{ fieldError('lastName') }}</div>
                    </div>

                    <div class="col-md-6">
                        <label for="celular" class="text-gray-600 small">Celular</label>
                        <input type="number" placeholder="" v-model="phone" id="celular" aria-label="celular"
                            :class="['form-control', 'form-control-solid', 'send-data', { 'is-invalid': fieldError('phone') }]"
                            onkeypress="isNumber(event)">
                        <div v-if="fieldError('phone')" class="invalid-feedback d-block">{{ fieldError('phone') }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="email" class="text-gray-600 small">Email</label>
                        <input
                            type="email"
                            inputmode="email"
                            autocomplete="email"
                            oncopy="return false"
                            onpaste="return false"
                            placeholder="nombre@correo.com"
                            id="email"
                            aria-label="email"
                            :class="['form-control', 'form-control-solid', 'send-data', { 'is-invalid': fieldError('email') }]"
                            v-model="email"
                            @blur="onEmailBlur"
                        >
                        <div v-if="fieldError('email')" class="invalid-feedback d-block">{{ fieldError('email') }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="emailConfirm" class="text-gray-600 small">Confirmaci&oacute;n Email</label>
                        <input
                            type="email"
                            inputmode="email"
                            autocomplete="email"
                            oncopy="return false"
                            onpaste="return false"
                            placeholder="Repetí tu email"
                            id="emailConfirm"
                            aria-label="Confirmación de email"
                            :class="['form-control', 'form-control-solid', 'send-data', { 'is-invalid': fieldError('emailConfirmation') }]"
                            v-model="emailConfirmation"
                            @blur="onEmailConfirmBlur"
                        >
                        <div v-if="fieldError('emailConfirmation')" class="invalid-feedback d-block">{{ fieldError('emailConfirmation') }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isValidEmail } from '@/utils/emailValidation';

export default {
    name: 'Header',
    components:{},
    data(){
        return {}
    },
    mounted() {
        this.generateID();
    },
    methods: {
        generateID(){
            this.$store.dispatch("person/setID", new Date().getTime());
        },
        fieldError(field) {
            return this.$store.getters["person/fieldError"](field) || "";
        },
        onEmailBlur() {
            const v = this.email != null ? String(this.email).trim() : "";
            if (!v) {
                this.$store.dispatch("person/setFieldError", { field: "email", message: "" });
                return;
            }
            if (!isValidEmail(v)) {
                this.$store.dispatch("person/setFieldError", { field: "email", message: "Email inválido" });
            } else {
                this.$store.dispatch("person/setFieldError", { field: "email", message: "" });
            }
        },
        onEmailConfirmBlur() {
            const v = this.emailConfirmation != null ? String(this.emailConfirmation).trim() : "";
            if (!v) {
                this.$store.dispatch("person/setFieldError", { field: "emailConfirmation", message: "" });
                return;
            }
            if (!isValidEmail(v)) {
                this.$store.dispatch("person/setFieldError", { field: "emailConfirmation", message: "Email inválido" });
                return;
            }
            const e = this.email != null ? String(this.email).trim() : "";
            if (e && isValidEmail(e) && v !== e) {
                this.$store.dispatch("person/setFieldError", { field: "emailConfirmation", message: "No coincide" });
            } else {
                this.$store.dispatch("person/setFieldError", { field: "emailConfirmation", message: "" });
            }
        }
    },
    computed: {
        name: {
            get() { return this.$store.state.person.name; },
            set(value) { this.$store.dispatch("person/setName", value); }
        },
        lastName: {
            get() { return this.$store.state.person.lastName; },
            set(value) { this.$store.dispatch("person/setLastName", value); }
        },
        phone: {
            get() { return this.$store.state.person.phone; },
            set(value) { this.$store.dispatch("person/setPhone", value); }
        },
        email: {
            get() { return this.$store.state.person.email; },
            set(value) { this.$store.dispatch("person/setEmail", value); }
        },
        emailConfirmation: {
            get() { return this.$store.state.person.emailConfirmation; },
            set(value) { this.$store.dispatch("person/setEmailConfirmation", value); }
        }
    },
    props: {
        step: String,
    }
}
</script>

<style lang="css" scoped></style>
